import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLineChart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 66 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M51.2178 23.3168C51.2178 24.3925 51.4567 25.4124 51.8843 26.3264L39.1987 35.4882C37.8588 34.0359 35.9395 33.1263 33.8078 33.1263C30.1467 33.1263 27.1123 35.8092 26.5633 39.3161H14.65C14.0259 36.0262 11.1354 33.5386 7.66394 33.5386C3.73673 33.5386 0.553101 36.7222 0.553101 40.6494C0.553101 44.5766 3.73673 47.7603 7.66394 47.7603C11.1354 47.7603 14.0259 45.2726 14.65 41.9827H26.6332C27.3344 45.3015 30.2802 47.7924 33.8078 47.7924C37.8577 47.7924 41.1408 44.5093 41.1408 40.4593C41.1408 39.5018 40.9573 38.5871 40.6235 37.7485L53.4469 28.4871C54.7205 29.6901 56.4384 30.4276 58.3286 30.4276C62.2558 30.4276 65.4395 27.244 65.4395 23.3168C65.4395 19.3896 62.2558 16.2059 58.3286 16.2059C54.4014 16.2059 51.2178 19.3896 51.2178 23.3168Z",
		fill: "#60A5FA"
	})
});
export default SvgLineChart;
